/*
 * Copyright (c) 2025.  Chad and contributors.
 * All rights reserved.
 */

import type {RouteRecordRaw} from 'vue-router';
import BaseStore from '@/views/store/Base.vue';
import type {CommonRouteMeta} from '@/types/common';

const storeComponent = () => import('@/views/store/index.vue');

const storeRoutes: RouteRecordRaw[] = [
    {
        path: '/store',
        component: BaseStore,
        meta: {
            hidden: true,
            noCache: false,
            requiresAuth: false,
            layout: 'Default',
        } as CommonRouteMeta,
        children: [
            {
                path: '',
                component: storeComponent,
                name: 'Store',
                meta: {title: 'store', icon: 'mdi-account-outline', noCache: false},
            },
        ],
    }
];

export default storeRoutes;
